export class AppTextarea extends HTMLElement {
  static get observedAttributes() {
    return ["label", "placeholder", "value", "disabled", "required", "error", "helper", "rows", "maxlength"];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  get value(): string {
    const textarea = this.querySelector("textarea");
    return textarea ? textarea.value : "";
  }

  set value(val: string) {
    const textarea = this.querySelector("textarea");
    if (textarea) {
      textarea.value = val;
    }
  }

  private render() {
    const label = this.getAttribute("label") || "";
    const placeholder = this.getAttribute("placeholder") || "";
    const value = this.getAttribute("value") || "";
    const disabled = this.hasAttribute("disabled");
    const required = this.hasAttribute("required");
    const error = this.getAttribute("error") || "";
    const helper = this.getAttribute("helper") || "";
    const rows = this.getAttribute("rows") || "3";
    const maxlength = this.getAttribute("maxlength") || "";

    const id = `textarea-${Math.random().toString(36).substring(2, 9)}`;

    this.innerHTML = `
      <div class="form-group">
        ${label ? `<label for="${id}" class="form-label ${required ? "required" : ""}">${label}</label>` : ""}
        <textarea
          id="${id}"
          class="form-textarea ${error ? "error" : ""}"
          placeholder="${placeholder}"
          rows="${rows}"
          ${maxlength ? `maxlength="${maxlength}"` : ""}
          ${disabled ? "disabled" : ""}
          ${required ? "required" : ""}
        >${value}</textarea>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          ${error ? `<span class="form-error">${error}</span>` : helper ? `<span class="form-helper">${helper}</span>` : "<span></span>"}
          ${maxlength ? `<span class="form-helper" style="font-family: var(--font-mono);">${String(value.length)}/${maxlength}</span>` : ""}
        </div>
      </div>
    `;
  }
}

if (!customElements.get("app-textarea")) {
  if (!customElements.get("app-textarea")) {
    customElements.define("app-textarea", AppTextarea);
  }
}
